import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

import { SvgIconComponent } from '../svg-icon/svg-icon.component';

@Component({
    selector: 'lib-plus-circle-icon',
    standalone: true,
    imports: [CommonModule, SvgIconComponent],
    templateUrl: './plus-circle-icon.component.html',
    styleUrl: './plus-circle-icon.component.css'
})
export class PlusCircleIconComponent {}
